var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showWidget)?_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
    callback: _vm.visibilityChanged,
    once: true
  }),expression:"{\n    callback: visibilityChanged,\n    once: true\n  }"}]},[(!_vm.$abtestConfigs.abTestWholeWidget.hideWholeWidget())?_c('PDPWidget',{attrs:{"itemId":_vm.itemId,"category":_vm.category}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }